// @flow

import { type Wizard, type ProductMessage, type WebsiteChatConfig, type WizardPageChosenOptions, type WizardPageData, type WizardSorting } from '@chatchamp/chatchamp-types'

import type { Notification, ScrollDirection, State } from './state'

export const mutations = {
  setCustomerConfig (state: State, value: WebsiteChatConfig) {
    state.customerConfig = value
  },
  pushVisitedPageId (state: State, pageId: number) {
    state.visitedPageIds.push(pageId)
  },
  removeVisitedPage (state: State, pageId: number) {
    const updatedVisitedPageIds = state.visitedPageIds.filter(visitedPageId => visitedPageId !== pageId)
    state.visitedPageIds = updatedVisitedPageIds
  },
  setRecommendedProducts (state: State, value: ProductMessage) {
    state.recommendedProducts = value
  },
  setIsLandingPage (state: State, value: boolean) {
    state.isLandingPage = value
  },
  setWizardPages (state: State, value: any) {
    state.wizardPages = value
  },
  setWizardPageIndex (state: State, value: number) {
    state.wizardPageIndex = value
  },
  setQuestionSelections (state: State, {
    wizardPageId,
    options
  }: { wizardPageId: number, options: WizardPageChosenOptions }) {
    state.selectedOptions[wizardPageId] = options
    state.selectedOptions = { ...state.selectedOptions }
  },
  cleanQuestionSelections (state: State, wizardPageId: ?number = null) {
    if (wizardPageId) {
      delete state.selectedOptions[wizardPageId]
      state.selectedOptions = { ...state.selectedOptions }
    } else {
      state.selectedOptions = {}
    }
  },
  setIsSavingWizardPageAnswer (state: State, value: boolean) {
    state.isSavingWizardPageAnswer = value
  },
  setWizardPageData (state: State, value: WizardPageData<any>) {
    state.wizardPageData = value
  },
  setWizard (state: State, value: Wizard) {
    state.wizard = value
  },
  setIsLoadingProducts (state: State, value: boolean) {
    state.isLoadingProducts = value
  },
  setHiddingProducts (state: State, value: boolean) {
    state.hiddingProducts = value
  },
  setSort (state: State, value: WizardSorting) {
    state.sort = value
  },
  setScrollDirection (state: State, value: ScrollDirection) {
    state.scrollDirection = value
  },
  setLatestLoadedProducts (state: State, value: Array<ProductMessage>) {
    state.latestLoadedProducts = value
  },
  setProductAddingToCart (state: State, productId: ?string) {
    state.productAddingToCart = productId
  },
  setRoutineAddingToCart (state: State, value: boolean) {
    state.routineAddingToCart = value
  },
  addProductToCart (state: State, productId: string) {
    state.cartProducts.push(productId)
  },
  setNotification (state: State, notification: Notification) {
    state.notification = notification
  }
}
